export var UnleashFeatureToggles;
(function (UnleashFeatureToggles) {
    UnleashFeatureToggles["BulkActionMenu"] = "CLUB_ADMIN_FLOATING_BULK_ACTION_MENU";
    UnleashFeatureToggles["CreateMentorship"] = "CLUB_ADMIN_CREATE_MENTORSHIP";
})(UnleashFeatureToggles || (UnleashFeatureToggles = {}));
